import {FaSearch, FaGripVertical, FaCode, FaInfo, FaRegImage, FaComments, FaAlignLeft, FaCircleNotch} from 'react-icons/fa';

export function getAvailableComponents(resourceType: string, excludeList: string[] = []) {
    let showComponents = []
      switch (resourceType){
      case "collection":
        !excludeList.includes("citation") && showComponents.push("citation")
        !excludeList.includes("citationTable") && showComponents.push("citationTable")
        !excludeList.includes("textCompare") && showComponents.push("textCompare")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        !excludeList.includes("convolution") && showComponents.push("convolution")
        //!excludeList.includes("NgramCompare") && showComponents.push("NgramCompare") // works but takes a long time; commenting for now to restrict to item level
        !excludeList.includes("witCompare") && showComponents.push("witCompare")
        break
      case "workGroup":
        !excludeList.includes("citation") && showComponents.push("citation")
        !excludeList.includes("citationTable") && showComponents.push("citationTable")
        //!excludeList.includes("workGroupInfo") && showComponents.push("workGroupInfo")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        break;
      case "person":
        !excludeList.includes("citation") && showComponents.push("citation")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        break;
      case "surface":
        !excludeList.includes("citation") && showComponents.push("citation")
        !excludeList.includes("codex") && showComponents.push("codex")
        !excludeList.includes("codexToc") && showComponents.push("codexToc")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        break;
      case "expressionType":
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        break;
      case "item":
        !excludeList.includes("citation") && showComponents.push("citation")
        // !excludeList.includes("textCitation") && showComponents.push("textCitation")
        !excludeList.includes("textCompare") && showComponents.push("textCompare")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("xml") && showComponents.push("xml")
        !excludeList.includes("textOutlineWrapper") && showComponents.push("textOutlineWrapper")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        //!excludeList.includes("chat") && showComponents.push("chat")
        !excludeList.includes("witCompare") && showComponents.push("witCompare")
        !excludeList.includes("citationTable") && showComponents.push("citationTable")
        // !excludeList.includes("convolution") && showComponents.push("convolution")
        !excludeList.includes("NgramCompare") && showComponents.push("NgramCompare")
        !excludeList.includes("nodeCommunities") && showComponents.push("nodeCommunities")
        break;
      case "division":
        !excludeList.includes("citation") && showComponents.push("citation")
        // !excludeList.includes("textCitation") && showComponents.push("textCitation")
        !excludeList.includes("textCompare") && showComponents.push("textCompare")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("xml") && showComponents.push("xml")
        !excludeList.includes("textOutlineWrapper") && showComponents.push("textOutlineWrapper")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        !excludeList.includes("witCompare") && showComponents.push("witCompare")
        !excludeList.includes("NgramCompare") && showComponents.push("NgramCompare")
        !excludeList.includes("citationTable") && showComponents.push("citationTable")
        break;
      case "block":
        !excludeList.includes("citation") && showComponents.push("citation")
        // !excludeList.includes("textCitation") && showComponents.push("textCitation")
        !excludeList.includes("textCompare") && showComponents.push("textCompare")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("xml") && showComponents.push("xml")
        !excludeList.includes("surface3") && showComponents.push("surface3")
        !excludeList.includes("textOutlineWrapper") && showComponents.push("textOutlineWrapper")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        !excludeList.includes("chat") && showComponents.push("chat")
        !excludeList.includes("nodeCommunities") && showComponents.push("nodeCommunities")
        break;
      case "element":
        !excludeList.includes("citation") && showComponents.push("citation")
        // !excludeList.includes("textCitation") && showComponents.push("textCitation")
        !excludeList.includes("textCompare") && showComponents.push("textCompare")
        !excludeList.includes("comments") && showComponents.push("comments")
        !excludeList.includes("search") && showComponents.push("search")
        !excludeList.includes("xml") && showComponents.push("xml")
        !excludeList.includes("surface3") && showComponents.push("surface3")
        !excludeList.includes("textOutlineWrapper") && showComponents.push("textOutlineWrapper")
        !excludeList.includes("resourceHistory") && showComponents.push("resourceHistory")
        !excludeList.includes("chat") && showComponents.push("chat")
        
        break;
      default:
        break;
      }
      return showComponents
}

export const getAvailableTabs = (tabs: Tab[], availableComponents: string[]) => {

  const availableTabs = tabs.filter((tab: Tab) => {
    return (availableComponents.includes(tab.name));
  })
  return availableTabs
}

interface Tab {
  name: string
  desc: string
  icon: JSX.Element
  
}

export const availableTabs: Tab[] = [
  {
    name: "citation",
    desc: "Text Citation",
    //show: true,
    icon: <FaInfo/>
  },
  {
  name: "surface3",
  desc: "Images",
  //show: true,
  icon: <FaRegImage/>
  },
  {
    name: "xml",
    desc: "Text XML Source",
    //show: true,
    icon: <FaCode/>
  },
  {
    name: "witCompare",
    desc: "witness comparison",
    //show: true,
    icon: <span>WC</span>
  },
  {
    name: "textCompare",
    desc: "Text Comparisons",
    //show: true,
    icon: <FaGripVertical/>
  },
  {
    name: "citationTable",
    desc: "citation table",
    //show: true,
    icon: <span>CT</span>
  },
  {
    name: "convolution",
    desc: "convolution list",
    //show: true,
    icon: <span>CL</span>
  },
  {
    name: "NgramCompare",
    desc: "Ngram Compare",
    //show: true,
    icon: <span>NC</span>
  },
  {
    name: "comments",
    desc: "Comments",
    //show: true,
    icon: <FaComments/>
  },
  {
    name: "textOutlineWrapper",
    desc: "Text Outline",
    //show: true,
    icon: <FaAlignLeft/>
  },
  {
    name: "codexToc",
    desc: "Codex Outline",
    //show: true,
    icon: <FaAlignLeft/>
  },
  {
    name: "search",
    desc: "Text Search",
    //show: true,
    icon: <FaSearch/>
  },
  {
    name: "nodeCommunities",
    desc: "node Communities",
    //show: true,
    icon: <FaCircleNotch/>
  },
  {
    name: "chat",
    desc: "chat with an AI assistant about this passage",
    //show: true,
    icon: <span>Chat</span>
  },
  {
    name: "resourceHistory",
    desc: "resource history",
    //show: true,
    icon: <span>H</span>
  }
  
  

]